import type { DscWorkbenchDashboardResponseV2 } from "@credit-acceptance/step6-bff-client";
import { useQuery } from "@tanstack/react-query";

import { dscWorkbenchQuery } from "../../../api/useDscWorkbench";
import type { DealStatusData } from "./types";

/**
 * Projects the Deal Status slices off the v2 dashboard response.
 * @param {DscWorkbenchDashboardResponseV2} dashboard - The dashboard payload.
 * @returns {DealStatusData} dealStatus, dealSummary and dealStatusFlags.
 */
export function selectDealStatus(dashboard: DscWorkbenchDashboardResponseV2): DealStatusData {
  return {
    dealStatus: dashboard.dealStatus,
    dealSummary: dashboard.dealSummary,
    flags: dashboard.dealStatusFlags,
  };
}

/**
 * Reads the Deal Status section data. Shares the dashboard query (same key and
 * fetch) with the rest of the review page, so it never issues a separate request.
 * @param {string} approvalId - The deal / approval identifier.
 * @returns {ReturnType<typeof useQuery<DscWorkbenchDashboardResponseV2, Error, DealStatusData>>} The TanStack Query result.
 */
export function useDealStatus(approvalId: string) {
  return useQuery({ ...dscWorkbenchQuery(approvalId), select: selectDealStatus });
}
